import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'markText',
    standalone: false
})
export class MarkTextPipe implements PipeTransform {
  transform(text: string, searchText: string): string {
    text = text.toString(); // ensure that our value is always a string

    if (searchText) {
      // escape backslashes in search text
      searchText = searchText.replace(/\\/g, '\\\\');

      text = text.replace(new RegExp(`(${searchText})`, 'gi'), (match) => {
        return `<mark>${match}</mark>`;
      });
    }

    return text;
  }
}
